import { Link } from 'react-router-dom';
import { userAvatar } from '../../assets';
import { useUserContext } from '../../context/user_context';
import { ICON_ARROW_RIGHT, ICON_BELL, ICON_LIST } from '../../utils/icons';
import { Hamburger, StyledTopNav } from './Nav.styled';
import { ThemeToggle } from '../../utils/ThemeToggle';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { decrypt } from '../../encrypt';
import { useLocalStorage } from '../../utils/useLocalStorage';
import { toast } from 'react-toastify';
import { useWebSocketContext } from '../../context/web_socket_context';


const TopNav = ({ pagename, route }) => {

    let navigate = useNavigate();
    const { notificationBadge } = useWebSocketContext();


    // Open Navbar 
    const openNav = (e) => {
        document.getElementById("mySidenav").style.width = "90vw";
    };
    // Open Navbar

    const {
        userPhoto,
        stats,
        businessData,
        storeData,
        getFeatureAccess, btoken, stoken, usertoken
    } = useUserContext();

    const unread = (stats?.unreadNotes + stats?.pendingRequests) || '0';


    const [featureacess, setfeatureAccess] = useLocalStorage('featureAccess');

    let featureAccess = decrypt(featureacess) || [];

    const ownerToken = businessData?.owner_token;

    // Function to Check if a user has Access to a Page or Not
    const checkFeature = (feature) => {
        if (featureAccess) {
            const data = featureAccess?.data?.findIndex(x => x === feature);
            if (data >= 0) {
                return true;
            } else {
                navigate('/user/dashboard');
                setTimeout(() => {
                    toast.info('Page not Authorized to User!!!');
                }, 10);
                return false;
            }
        }
    };
    // Function to Check if a user has Access to a Page or Not

    // Check if a business is active or inactive before routing
    function checkActive(e) {
        if (businessData?.active === '0') {

            // Check if user is biz owner, if not route to inactive biz page
            if (usertoken !== ownerToken) {
                navigate("/user/settings/noAccess");
            } else {

                // check if page is billing, packages or make payment, if not route to biz inactive page
                if (e !== 'upgrade') {
                    navigate("/user/settings/noAccess");
                    setTimeout(() => {
                        toast.warn('This Business is Inactive..');
                    }, 10);
                }
            }
        }
    }

    // Check if Business Token and Store Token is availble 
    function checkTokens() {
        if (!stoken || !btoken) {
            navigate("/login");
            setTimeout(() => {
                toast.warn('Please login again..');
            }, 10);
        }
    }
    // Check if Business Token and Store Token is availble 

    useEffect(() => {
        getFeatureAccess();
        checkFeature(pagename);
        checkActive(route);
        checkTokens();
    }, []);


    return (
        <StyledTopNav
            className="bottom-border fixed-top navbar navbar-expand-sm navbar-light"
        >
            <div className="container-fluid">
                <div className="d-flex">
                    <Hamburger
                        onClick={(e) => openNav(e)}
                    >
                        {ICON_LIST}
                    </Hamburger>

                    <h6 className="m-0 text-truncate text-uppercase col-9 page-title pry-text fw-bold">
                        {businessData?.name}
                        <span className="mx-2 h4">
                            {ICON_ARROW_RIGHT}
                        </span>
                        {storeData?.storename}
                    </h6>
                </div>
                <li className="d-flex mr-auto ml-5 pl-4 list-unstyled">
                    {/* <div className="d-sm-block d-none">
                        <ThemeToggle />
                    </div> */}
                    <Link to='/user/notifications'
                        className='mx-2 grey-bold-text'
                    >
                        <span className="position-relative" >
                            {ICON_BELL}
                            {notificationBadge &&
                                <span className="position-absolute m-0 p-2 rounded-pill translate-middle bell badge pry light-text"
                                > </span>
                            }
                            {/* {unread >= 1 &&
                                <span className="position-absolute m-0 rounded-pill translate-middle bell badge pry light-text"
                                >
                                    {unread > 99 ? '99+' : unread}
                                </span>
                            } */}
                        </span>
                    </Link>
                    <Link to='#'
                        className='mx-2 grey-bold-text'
                    >
                        <img src={userPhoto || userAvatar} alt="user_picture" />
                    </Link>
                </li>

            </div>
        </StyledTopNav>
    );
};

export default TopNav;